export * from './equal-validator';
export * from './custom-validator';



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/validators/index.ts